// extracted by mini-css-extract-plugin
export default {"relatedNorms__headerCellBtn":"RelatedNormsTable_relatedNorms__headerCellBtn__wgRip","norms__name":"RelatedNormsTable_norms__name__pZkBS"};